import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "deactive-actions-table" };
const _hoisted_2 = { class: "el-table__column" };
const _hoisted_3 = { style: { "text-align": "right" } };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", { class: "deactive-actions-table__dropdown__button" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-menu-14px" })
], -1);
import { reactive, watch, ref, h } from 'vue';
import { useToast } from 'vue-toastification';
import i18n from '@/i18n';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import ListPagination from '@/components/_atoms/ListPagination.vue';
import ModalConfirmEditActions from '@/features/CampaignsManagement/components/ModalConfirmEditActions.vue';
import EmptyTableDeactiveAction from '@/features/CampaignsManagement/components/EmptyTableDeactiveAction.vue';
import { fetchActionsList } from '../data/fetchActionsList';
import { postActivateDeactivate } from '../data/postActivateDeactivate';
import { useRedirect } from '../composables';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DeactiveActionsTable',
    props: {
        selectedTab: {}
    },
    setup(__props) {
        const props = __props;
        const state = reactive({
            pagination: {
                limit: 20,
                page: 1,
                count: 0,
            },
            loading: false,
            tableHeader: [],
            hasError: false,
            id: 'deactive-actions-table',
            tableData: [],
            search: '',
            isPastDateWarningModalVisible: false,
            selectedAction: {
                action: '',
                campaignsApproval: null,
                createDate: '',
                enabled: false,
                enabledApproval: false,
                id: '',
                isActivable: false,
                period: '',
                priority: 0,
                actionCategory: null,
                revenuePerContact: 0,
            },
        });
        const table = ref(null);
        const toast = useToast();
        const { redirectToEditActionPage } = useRedirect();
        const confirmActionActivation = (action) => {
            if (!action.actionCategory) {
                toast.error(h('div', {
                    innerHTML: i18n.global.t('campaigns-management.deactive-actions.error-category'),
                    class: 'Vue-Toastification__toast-body',
                }), {
                    timeout: 7000,
                });
                return;
            }
            state.selectedAction = action;
            if (!action.isActivable) {
                state.isPastDateWarningModalVisible = true;
                return;
            }
            activeAction();
        };
        const activeAction = () => {
            state.loading = true;
            state.isPastDateWarningModalVisible = false;
            state.tableData = [];
            const params = {
                actionId: state.selectedAction.id,
                enabled: 1,
            };
            postActivateDeactivate(params).then((isSuccessful) => {
                if (isSuccessful) {
                    resetPagination();
                    fetchDataTable();
                    if (!state.selectedAction.isActivable) {
                        toast.warning(i18n.global.t('campaigns-management.modals.confirm-activation-past-date.success'), {
                            timeout: 8000,
                        });
                        return;
                    }
                    toast.success(i18n.global.t('campaigns-management.deactive-actions.active'), {
                        timeout: 4000,
                    });
                }
                else {
                    state.hasError = true;
                    toast.error(i18n.global.t('campaigns-management.deactive-actions.active'), {
                        timeout: 5000,
                    });
                    state.loading = false;
                }
            });
        };
        const fetchDataTable = async (typeFetch) => {
            state.loading = true;
            if (typeFetch === 'search') {
                resetPagination();
            }
            const params = {
                enabled: 0,
                page: state.pagination.page,
                limit: state.pagination.limit,
                term: state.search,
            };
            await fetchActionsList(params).then(response => {
                if (response?.success) {
                    state.tableData = response.data;
                    state.pagination.count = response.totalCount;
                    state.tableHeader = response.columns;
                    state.tableHeader.push({ label: '', key: 'actions' });
                }
                else {
                    state.hasError = true;
                }
                state.loading = false;
            });
        };
        const resetPagination = () => {
            state.pagination.page = 1;
        };
        const resetFilterAndPagination = () => {
            state.search = '';
            fetchDataTable();
            resetPagination();
        };
        const getColumnName = (key) => {
            return state.tableHeader.filter(column => column.key === key)[0]['label'];
        };
        const getColumnWidth = (columnKey) => {
            const width = {
                priority: 55,
                name: 268,
                period: 200,
                actions: 35,
            };
            return width[columnKey];
        };
        watch(() => props.selectedTab, () => {
            if (props.selectedTab === 'deactive') {
                state.search = '';
                resetPagination();
                fetchDataTable();
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_router_link = _resolveComponent("router-link");
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(ModalConfirmEditActions, {
                    id: "confirm-activation-past-date",
                    "is-visible": state.isPastDateWarningModalVisible,
                    onSave: activeAction,
                    onHide: _cache[0] || (_cache[0] = () => (state.isPastDateWarningModalVisible = false))
                }, null, 8, ["is-visible"]),
                _createElementVNode("div", _hoisted_1, [
                    (!state.loading)
                        ? (_openBlock(), _createBlock(_component_el_table, {
                            key: 0,
                            data: state.tableData,
                            style: { "width": "100%" },
                            "empty-text": ' ',
                            ref_key: "table",
                            ref: table,
                            class: _normalizeClass({ 'deactive-actions-table--blocked': !state.tableData.length && !state.search })
                        }, {
                            empty: _withCtx(() => [
                                (!state.tableData.length && state.search)
                                    ? (_openBlock(), _createBlock(InfoCard, {
                                        key: 0,
                                        ref: "message-error",
                                        error: state.hasError && !state.loading
                                    }, null, 8, ["error"]))
                                    : _createCommentVNode("", true),
                                (!state.tableData.length && !state.search)
                                    ? (_openBlock(), _createBlock(EmptyTableDeactiveAction, { key: 1 }))
                                    : _createCommentVNode("", true),
                                (state.loading)
                                    ? (_openBlock(), _createBlock(BaseLoader, { key: 2 }))
                                    : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.tableHeader, (column, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: index,
                                        prop: column.key,
                                        label: column.label,
                                        "min-width": getColumnWidth(column.key)
                                    }, _createSlots({
                                        default: _withCtx((scope) => [
                                            (column.key === 'name')
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 0,
                                                    title: scope.row.action,
                                                    to: `/campaigns/campaigns/edit/${scope.row.id}`,
                                                    class: "deactive-actions-table__name"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(scope.row.action), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["title", "to"]))
                                                : _createCommentVNode("", true),
                                            (column.key === 'actions')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                    _createVNode(_component_el_dropdown, {
                                                        trigger: "click",
                                                        class: "deactive-actions-table__dropdown"
                                                    }, {
                                                        dropdown: _withCtx(() => [
                                                            _createVNode(_component_el_dropdown_menu, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_el_dropdown_item, {
                                                                        onClick: ($event) => (confirmActionActivation(scope.row))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.$t('activate')), 1)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]),
                                                                    _createVNode(_component_el_dropdown_item, {
                                                                        onClick: ($event) => (_unref(redirectToEditActionPage)(scope.row))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.$t('edit')), 1)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"])
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _hoisted_5
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, [
                                        (column.key === 'name')
                                            ? {
                                                name: "header",
                                                fn: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_2, [
                                                        _createElementVNode("label", null, _toDisplayString(getColumnName(column.key)), 1),
                                                        _createVNode(_component_el_popover, {
                                                            trigger: "hover",
                                                            placement: "bottom",
                                                            width: 260
                                                        }, {
                                                            reference: _withCtx(() => [
                                                                _createElementVNode("i", {
                                                                    class: _normalizeClass([{
                                                                            'color-oto-brand-omni': !!state.search,
                                                                        }, "icon icon-search-12px ml--4"])
                                                                }, null, 2)
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_el_input, {
                                                                    modelValue: state.search,
                                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((state.search) = $event)),
                                                                    size: "small",
                                                                    ref_for: true,
                                                                    ref: column.key,
                                                                    placeholder: _ctx.$t('table-column.placeholder'),
                                                                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event) => (fetchDataTable('search')), ["enter"]))
                                                                }, null, 8, ["modelValue", "placeholder"]),
                                                                _createElementVNode("div", _hoisted_3, [
                                                                    _createVNode(_component_el_button, {
                                                                        round: "",
                                                                        size: "small",
                                                                        text: "",
                                                                        onClick: resetFilterAndPagination,
                                                                        disabled: !state.search
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(state.search ? _ctx.$t('table-column.btn-reset') : _ctx.$t('table-column.btn-cancel')), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["disabled"]),
                                                                    _createVNode(_component_el_button, {
                                                                        disabled: !state.search,
                                                                        round: "",
                                                                        size: "small",
                                                                        type: "primary",
                                                                        onClick: _cache[3] || (_cache[3] = ($event) => (fetchDataTable('search')))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.$t('table-column.btn-search')), 1)
                                                                        ]),
                                                                        _: 1
                                                                    }, 8, ["disabled"])
                                                                ])
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ])
                                                ]),
                                                key: "0"
                                            }
                                            : undefined
                                    ]), 1032, ["prop", "label", "min-width"]));
                                }), 128))
                            ]),
                            _: 1
                        }, 8, ["data", "class"]))
                        : (_openBlock(), _createBlock(BaseLoader, { key: 1 })),
                    (!state.loading || !state.pagination.count)
                        ? (_openBlock(), _createBlock(ListPagination, {
                            key: 2,
                            data: state.pagination,
                            limit: state.pagination.limit,
                            "limit-range": [5, 10, 20, 30, 50],
                            identify: state.id,
                            "show-list-pages": false,
                            "show-quantity-lines": true,
                            onChangePage: fetchDataTable
                        }, null, 8, ["data", "limit", "identify"]))
                        : _createCommentVNode("", true)
                ])
            ], 64));
        };
    }
});
